<template>
  <Layout>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :z-index="zIndex"></loading>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <h4 class="page-title">Candidate Personal Data and CV 
            <span v-if="GeneralData">
              <span v-if="GeneralData.name">{{ ' - ' + GeneralData.name + ' ' + GeneralData.surname }}</span>
              <span v-if="GeneralData.email">{{ (GeneralData.email) ? ' (' + GeneralData.email + ')' : '' }}</span>
            </span>
          </h4>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <navigation :item="1" :save="save" :user="user"></navigation>
          <div class="card-body">
            <div class="row">
              <div class="card col-md-12">
                <div class="card-body">
                  <div class="alert alert-info mb-3">
                    <b>Info</b> General data are the same for all agencies. If changed, it will affect all the different CVs registered for the candidate.
                  </div>
                  <div class="row">
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                        <label for="Name">First Name <span v-if="checkLabelRequired('name')" class="text-danger">*</span></label>
                        <div class="input-group"> 
                          <div class="input-group-prepend">
                            <span id="basic-addon1" class="input-group-text"><i class="fas fa-user"></i></span>
                          </div>
                          <b-form-input id="Name" v-model="GeneralData.name" :state="validateState('name')" type="text" class="form-control" maxlength="100"/>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                        <label for="Surname">Last Name <span v-if="checkLabelRequired('surname')" class="text-danger">*</span></label>
                        <div class="input-group"> 
                          <div class="input-group-prepend">
                            <span id="basic-addon1" class="input-group-text"><i class="fas fa-user"></i></span>
                          </div>
                          <b-form-input id="Surname" v-model="GeneralData.surname" :state="validateState('surname')" type="text" class="form-control" maxlength="100"/>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                        <label for="Email">E-mail <span class="text-danger">*</span></label>
                        <div class="input-group"> 
                          <div class="input-group-prepend">
                            <span id="basic-addon1" class="input-group-text"><i class="fas fa-envelope"></i></span>
                          </div>
                          <b-form-input id="Email" v-model="GeneralData.email" :state="validateState('email')" type="email" class="form-control" maxlength="200" @blur="checkEmail"/>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                        <label for="Gender">Gender Identity <span v-if="checkLabelRequired('genderId')" class="text-danger">*</span></label>   
                        <div class="input-group"> 
                          <b-form-select v-model="GeneralData.genderId" :state="validateState('genderId')" :options="genders" value-field="id" text-field="name"></b-form-select>
                        </div>
                        <div v-if="GeneralData.genderId === '99' || GeneralData.genderId === 99" class="input-group mt-2"> 
                          <b-form-input id="name-input" v-model="GeneralData.genderDescription" :state="$v.GeneralData.genderDescription.$dirty ? !$v.GeneralData.genderDescription.$error : null" placeholder="Please specify"></b-form-input>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                        <label for="PhoneMobile">Mobile Phone <span v-if="checkLabelRequired('phoneMobile')" class="text-danger">*</span></label>
                        <div class="input-group"> 
                          <div class="input-group-prepend">
                            <span id="basic-addon1" class="input-group-text"><i class="fas fa-phone"></i></span>
                          </div>
                          <b-form-input id="PhoneMobile" v-model="GeneralData.phoneMobile" :state="validateState('phoneMobile')" type="text" class="form-control" maxlength="100"/>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                        <label for="PhoneWork">Work Phone <span v-if="checkLabelRequired('phoneWork')" class="text-danger">*</span></label>
                        <div class="input-group"> 
                          <div class="input-group-prepend">
                            <span id="basic-addon1" class="input-group-text"><i class="fas fa-phone"></i></span>
                          </div>
                          <b-form-input id="PhoneWork" v-model="GeneralData.phoneWork" :state="validateState('phoneWork')" type="text" class="form-control" name="PhoneWork" maxlength="100"/>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                        <label for="PhonePrivate">Private Phone <span v-if="checkLabelRequired('phonePrivate')" class="text-danger">*</span></label>   
                        <div class="input-group"> 
                          <div class="input-group-prepend">
                            <span id="basic-addon1" class="input-group-text"><i class="fas fa-phone"></i></span>
                          </div>
                          <b-form-input id="PhonePrivate" v-model="GeneralData.phonePrivate"  :state="validateState('phonePrivate')" type="text" class="form-control" name="PhonePrivate" maxlength="100"/>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                        <label for="BirthPlace">Birthday Date <span v-if="checkLabelRequired('birthPlace')" class="text-danger">*</span></label>   
                        <b-input-group class="mb-3">
                          <b-form-input 
                            id="BirthPlace"                              
                            v-mask="['##/##/####']" 
                            type="text" 
                            placeholder="DD/MM/YYYY" 
                            autocomplete="off"
                            :value="GeneralData.birthPlace"
                            :state="validateState('birthPlace')" 
                            @blur="onBlurBirthPlace">                       
                          </b-form-input>
                          <b-input-group-append>
                            <b-form-datepicker 
                              v-model="birthPlaceObj" 
                              button-only 
                              close-button 
                              locale="pt" 
                              right  
                              :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }" 
                              @input="updateBirthPlace">
                            </b-form-datepicker>
                          </b-input-group-append>
                        </b-input-group>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                        <label for="CurrentNationality">Nationality <span v-if="checkLabelRequired('currentNationalityId')" class="text-danger">*</span></label>   
                        <div class="input-group"> 
                          <b-form-select v-model="GeneralData.currentNationalityId" :state="validateState('currentNationalityId')" :options="countries" value-field="id" text-field="name"></b-form-select>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                        <label for="Cpf">CPF (Brazilians only) <span v-if="checkLabelRequired('cpf')" class="text-danger">*</span></label>   
                        <div class="input-group"> 
                          <div class="input-group-prepend">
                            <span id="basic-addon1" class="input-group-text"><i class="fas fa-user-tie"></i></span>
                          </div>
                          <b-form-input id="Cpf" v-model="GeneralData.cpf" v-mask="['###.###.###-##']" :state="validateState('cpf')" type="text" class="form-control" name="Cpf" maxlength="20" />
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                        <label for="Rg">ID / RG / Passport <span v-if="checkLabelRequired('rg')" class="text-danger">*</span></label>   
                        <div class="input-group"> 
                          <div class="input-group-prepend">
                            <span id="basic-addon1" class="input-group-text"><i class="fas fa-user-tie"></i></span>
                          </div>
                          <b-form-input id="Rg" v-model="GeneralData.rg" :state="validateState('rg')" type="text" class="form-control" name="Rg" maxlength="10"/>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                        <label for="CivilState">Marital Status <span v-if="checkLabelRequired('civilStateId')" class="text-danger">*</span></label>   
                        <div class="input-group"> 
                          <b-form-select v-model="GeneralData.civilStateId" :state="validateState('civilStateId')" :options="civilState" value-field="id" text-field="name"></b-form-select>
                        </div>
                      </div>
                    </b-col>
                  </div>
                  <div class="row">
                    <b-col cols="12" sm="6" md="6" lg="6" xl="6">
                      <div class="form-group">
                          <label for="Address">Address <span v-if="checkLabelRequired('address')" class="text-danger">*</span></label>
                          <div class="input-group"> 
                          <div class="input-group-prepend">
                              <span id="basic-addon1" class="input-group-text"><i class="fas fa-directions"></i></span>
                          </div>
                          <b-form-input id="Address" v-model="GeneralData.address" :state="$v.GeneralData.address.$dirty ? !$v.GeneralData.address.$error : null" type="text" class="form-control" name="Address" maxlength="150"/>
                          </div>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="6" xl="6">  
                      <div class="form-group">
                          <label for="AddressComplement">Apartment / Suite / Other <span v-if="checkLabelRequired('addressComplement')" class="text-danger">*</span></label>
                          <div class="input-group"> 
                          <div class="input-group-prepend">
                              <span id="basic-addon1" class="input-group-text"><i class="fas fa-directions"></i></span>
                          </div>
                          <b-form-input id="AddressComplement" v-model="GeneralData.addressComplement" :state="$v.GeneralData.addressComplement.$dirty ? !$v.GeneralData.addressComplement.$error : null" type="text" class="form-control" name="AddressComplement" maxlength="100"/>
                          </div>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                          <label for="Country">Country <span v-if="checkLabelRequired('countryId')" class="text-danger">*</span></label>   
                          <div class="input-group"> 
                            <b-form-select v-model="GeneralData.countryId" :state="$v.GeneralData.countryId.$dirty ? !$v.GeneralData.countryId.$error : null" :options="countries" value-field="id" text-field="name"></b-form-select>
                          </div>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                          <label for="CurrentNationality">State <span v-if="checkLabelRequired('stateId')" class="text-danger">*</span></label>   
                          <div class="input-group"> 
                            <b-form-select v-model="GeneralData.stateId" :state="$v.GeneralData.stateId.$dirty ? !$v.GeneralData.stateId.$error : null" :options="states" value-field="id" text-field="name" :disabled="stateDisable"></b-form-select>
                          </div>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                          <label for="CurrentNationality">City <span v-if="checkLabelRequired('cityId')" class="text-danger">*</span></label>   
                          <div class="input-group"> 
                            <b-form-select v-model="GeneralData.cityId" :state="$v.GeneralData.cityId.$dirty ? !$v.GeneralData.cityId.$error : null" :options="cities" value-field="id" text-field="name" :disabled="cityDisable"></b-form-select>
                          </div>
                      </div>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" lg="3" xl="3">
                      <div class="form-group">
                          <label for="zipCode">CEP / Zip Code <span v-if="checkLabelRequired('zipCode')" class="text-danger">*</span></label>
                          <div class="input-group"> 
                          <div class="input-group-prepend">
                              <span id="basic-addon1" class="input-group-text"><i class="fas fa-directions"></i></span>
                          </div>
                          <b-form-input id="zipCode" v-model="GeneralData.zipCode" v-mask="['#####-###']" :state="$v.GeneralData.zipCode.$dirty ? !$v.GeneralData.zipCode.$error : null" type="text" class="form-control" name="zipCode" maxlength="20"/>
                          </div>
                      </div>
                    </b-col>
                  </div>
                  <div class="row">  
                    <div class="form-group col-md-3 col-xs-12">
                      <label for="zipCode">LGBTQIA+ community <span v-if="checkLabelRequired('lgbtqia')" class="text-danger">*</span></label>
                      <div class="input-group"> 
                        <b-form-radio-group id="lgbtqia" v-model="GeneralData.lgbtqia" :state="$v.GeneralData.lgbtqia.$dirty ? !$v.GeneralData.lgbtqia.$error : null" type="text">
                          <b-form-radio name="lgbtqia" value="true">Yes</b-form-radio>
                          <b-form-radio class="ml-2" name="lgbtqia" value="false">No</b-form-radio>
                        </b-form-radio-group>
                      </div>
                    </div>
                    <div class="form-group col-md-3 col-xs-12">
                      <label for="zipCode">Color/race <span v-if="checkLabelRequired('colorRaceId')" class="text-danger">*</span></label>
                      <div class="input-group"> 
                        <div class="input-group"> 
                            <b-form-select v-model="GeneralData.colorRaceId" :state="$v.GeneralData.colorRaceId.$dirty ? !$v.GeneralData.colorRaceId.$error : null" :options="colorRace" value-field="id" text-field="name"></b-form-select>
                          </div>
                      </div>
                    </div>
                    <div class="form-group col-md-3 col-xs-12">
                      <label for="disability">Disability <span v-if="checkLabelRequired('disability')" class="text-danger">*</span></label>
                      <br><small><i>Do you identify yourself as a person with a disability?</i></small>
                      <div class="input-group"> 
                        <b-form-radio-group id="disability" v-model="GeneralData.disability" :state="$v.GeneralData.disability.$dirty ? !$v.GeneralData.disability.$error : null">
                          <b-form-radio name="lgbtqia" value="true">Yes</b-form-radio>
                          <b-form-radio class="ml-2" name="lgbtqia" value="false">No</b-form-radio>
                        </b-form-radio-group>
                      </div>
                      <div v-if="GeneralData.disability === 'true' || GeneralData.disability === true" class="input-group mt-2"> 
                        <b-form-input id="name-input" v-model="GeneralData.disabilityDescription" :state="$v.GeneralData.disabilityDescription.$dirty ? !$v.GeneralData.disabilityDescription.$error : null" placeholder="Please specify"></b-form-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="GeneralData.updatedBy">
              Modified by <b>{{ GeneralData.updatedBy.name }} {{ GeneralData.updatedBy.surname }}</b> ({{ GeneralData.updatedByAgency.name }}) at {{ GeneralData.updatedAt | formatDateTime }}.
            </div>
          </div>
          <b-button variant="success" class="btn-rounded float-right" @click="save('curriculum')">
            Save & Next
          </b-button>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import axios from 'axios'
import loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import navigation from './navigation'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import moment from 'moment'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';

var qs = require('qs')

export default {
  components: { Layout, loading, navigation },
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    agency: {
      type: Object,
      required: true,
      default: () => ({}),
    }
  },
  page: {
    title: 'Add Candidate',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data () {
    return {
      CandidateId: (this.$route.params.id) ? this.$route.params.id : '',
      GeneralData: {},
      momentFormat: {
        stringify: (date) => {
          return date ? moment(date).format('DD/MM/YYYY') : ''
        },
        parse: (value) => {
          return value ? moment(value, 'DD/MM/YYYY').toDate() : null
        }
      },
      genders: [],
      countries: [],
      states: [],
      civilState: [],
      cities: [],
      stateDisable: true,
      cityDisable: true,
      isLoading: true,
      fullPage: false,
      zIndex: 9999,
      requiredFields: [],
      requiredAddressFields: [],
      formatedDate: null,
      colorRace: []
    }
  },
  validations() {
    return { 
      GeneralData: {
        email: { required, email },
        genderId: this.checkDynamicRequired('genderId'),
        name: this.checkDynamicRequired('name'),
        surname: this.checkDynamicRequired('surname'),
        phoneMobile: this.checkDynamicRequired('phoneMobile'),
        birthPlace: this.checkDynamicRequired('birthPlace'),
        currentNationalityId: this.checkDynamicRequired('currentNationalityId'),
        civilStateId: this.checkDynamicRequired('civilStateId'),
        phoneWork: this.checkDynamicRequired('phoneWork'),
        phonePrivate: this.checkDynamicRequired('phonePrivate'),
        cpf: this.checkDynamicRequired('cpf'),
        rg: this.checkDynamicRequired('rg'),
        // Address
        address: this.checkDynamicRequired('address'),
        countryId: this.checkDynamicRequired('countryId'),
        addressComplement: this.checkDynamicRequired('addressComplement'),
        stateId: this.checkDynamicRequired('stateId'),
        cityId: this.checkDynamicRequired('cityId'),
        zipCode: this.checkDynamicRequired('zipCode'),
        lgbtqia: this.checkDynamicRequired('lgbtqia'),
        colorRaceId: this.checkDynamicRequired('colorRaceId'),
        disability: this.checkDynamicRequired('disability'),
        disabilityDescription: (this.GeneralData.disability === true || this.GeneralData.disability === 'true') ? this.checkDynamicRequired('disability') : {},
        genderDescription: (this.GeneralData.genderId === 99 || this.GeneralData.genderId === '99') ? this.checkDynamicRequired('genderId') : {}
      }
    }
  },
   computed: {
    // a computed getter
    birthPlaceObj() {
      // `this` points to the component instance
       if (this.GeneralData.birthPlace) {
         return moment(this.GeneralData.birthPlace, "DD/MM/YYYY").toDate()
       } else {
        return moment().toDate()
      }     
    }
  },
  watch: {
    'GeneralData.countryId': {
      handler: function (value) {
        this.loadStates()
      }
    },
    'GeneralData.stateId': {
      handler: function (value) {
        if(value > 0) {
          this.loadCities()
        }
      }
    },
    states: {
      handler: function (value) {
        if(value.length === 0) {
          this.GeneralData.stateId = ''
          this.GeneralData.cityId = ''
          this.stateDisable = true
          this.cityDisable = true
        }
        else {
          this.stateDisable = false
        }
      }
    },
    cities: {
      handler: function (value) {
        if(value.length === 0) {
          this.GeneralData.cityId = ''
          this.cityDisable = true
        }
        else {
          this.cityDisable = false
        }
      }
    }
  },
  created: function() {
    this.loadGender()
    this.loadRequiredFields()
    this.loadCurriculum()
  },
  methods: {
    ...authMethods,
    validateState (name) {
      const { $dirty, $error } = this.$v.GeneralData[name];
      return $dirty ? !$error : null;
    },
    formatDate(date) {
      return date ? moment(date, 'DD/MM/YYYY') : null
    },
    onDateChange (ctx) {
      this.formatedDate = ctx.selectedFormatted
    },
    loadGender() {
      axios.get(appConfig.apiUrl + 'gender',
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.genders = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
      .finally(() => {
        this.loadColorRace()
      })
    },
    loadColorRace() {
      axios.get(appConfig.apiUrl + 'color-race',
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.colorRace = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
      .finally(() => {
        this.loadCivilState()
      })
    },
    loadRequiredFields () {
      axios.get(`${appConfig.apiUrl}required-fields/${this.agency.id}/only/generalData`,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.requiredFields = response.data
      })
      .finally(() => {
        this.loadRequiredAddressFields()
      })
    },
    loadRequiredAddressFields () {
      axios.get(`${appConfig.apiUrl}required-fields/${this.agency.id}/only/address`,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.requiredFields = this.requiredFields.concat(response.data)
      })
    },
    checkDynamicRequired (field) {
      if (this.requiredFields.find(f => f.aliasId === field && f.selected === true)) {
        if(field === 'cpf' && this.GeneralData.currentNationalityId !== 1) {
          return {}
        }
        return { required }
      }
      return {}
    },
    checkLabelRequired (field) {
      if (this.requiredFields.find(f => f.aliasId === field && f.selected === true)) {
        if(field === 'cpf' && this.GeneralData.currentNationalityId !== 1) {
          return false
        }
        return true
      }
      return false
    },
    loadCivilState () {
      axios.get(appConfig.apiUrl + 'civil-state',
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.civilState = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
      .finally(() => {
        this.loadCountries()
      })
    },
    loadCountries () {
      axios.get(appConfig.apiUrl + 'country',
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.countries = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    loadStates() {
      axios.get(appConfig.apiUrl + 'state/' + this.GeneralData.countryId,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.states = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
    },
    loadCities() {
      axios.get(appConfig.apiUrl + 'city/' + this.GeneralData.stateId,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.cities = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
    },
    loadCurriculum() {
      if(this.CandidateId.length > 0) {
        axios.get(appConfig.apiUrl + 'candidate/' + this.CandidateId,
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
        .then((response) => {
          if(response.data) {
            this.GeneralData = response.data
            this.GeneralData.birthPlace = moment(this.GeneralData.birthPlace).format("DD/MM/YYYY")
          }
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
        })
      }
    },
    loadCandidate() {
      if(this.GeneralData.email.length > 0) {
        this.isLoading = true
        axios.get(appConfig.apiUrl + 'candidate/email/' + this.GeneralData.email,
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
        .then((response) => {
          if(response.data) {
            if(response.data.id !== this.GeneralData.id) {
              this.GeneralData = response.data
              this.GeneralData.birthPlace = moment(this.GeneralData.birthPlace).format("DD/MM/YYYY")
            }
          }
          else if (!response.data) {
            // this.GeneralData = {}
          }
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
        })
      }
    },
    checkEmail() {
      this.loadCandidate()
    },
    save(nextTab) {
      this.$v.GeneralData.$reset()
      this.$v.GeneralData.$touch()     
     
      if (this.$v.GeneralData.$anyError) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.'});
        return
      }

      let genData = this.GeneralData;
      if (genData.birthPlace) {
        genData.birthPlace = moment(this.GeneralData.birthPlace, "DD/MM/YYYY").format("MM/DD/YYYY")
      }

      this.isLoading = true
      axios.post(appConfig.apiUrl + 'candidate/save',
        qs.stringify(genData),
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          if(response.data) {
            this.$router.push(`/app/candidate/${nextTab}/${response.data.id}`)
          }
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
        })
    }
    ,
    updateBirthPlace(value) {
      if (value) {
         this.GeneralData.birthPlace = moment(value).format("DD/MM/YYYY")
      }     
    },
    onBlurBirthPlace(ctx) {
      this.GeneralData.birthPlace = ctx.target.value
    }
  }
}
</script>
